module.exports = __webpack_public_path__ + "img/dcom08.c79a2d38.png";